/** Grupos CO (proyecto M37 = grupo Control Operativo). Alineado con server/api/m37_co_delivery_rules.php */

export const M37_CO_GROUPS = [
  { key: 'linea_viva', label: 'Línea viva' },
  { key: 'proyectos', label: 'Proyectos' },
  { key: 'gruas', label: 'Grúas' },
  { key: 'alumbrado_publico', label: 'Alumbrado público' },
];

export const M37_DOCUMENT_CO_GROUPS = ['proyectos'];

export function normalizeM37CoGroup(raw) {
  const s = String(raw ?? '').trim().toLowerCase().replace(/[\s-]+/g, '_');
  const map = {
    línea_viva: 'linea_viva',
    linea: 'linea_viva',
    grúas: 'gruas',
    alumbrado: 'alumbrado_publico',
  };
  return map[s] || s;
}
